import React from 'react'
import { makeStyles, Tabs, AppBar, Box, Tab, Typography } from '@material-ui/core'
import { DEFAULT_COLOR } from '../../Helper/GlobalConstants';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: DEFAULT_COLOR,
        // marginTop: '60px',
        // marginLeft: 240,

    },
    tabTextColor: {
        color: 'white'
    }
}))

export default function SecondaryNavbar({ navigation }) {
    let classes = useStyles();
    const history = useHistory();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
        <div className={classes.root}>

            <Tabs
                
                
                variant="scrollable"
                classes={{
                    selected: {
                        color: 'white'
                    }
                }}
                scrollButtons="auto"
                aria-label="scrollable tabs"
                value={value}
                onChange={handleChange}
            >
                {navigation.map((el, index) =>
                    <Tab
                        className={classes.tabTextColor}
                        key={index}
                        component="a"

                        onClick={event => {
                            event.preventDefault();
                            history.push(el.path);
                        }}
                        label={el.title} />
                )}

            </Tabs>



        </div>
    )
}

